const FLOW = 'crc_flow_override';
const TOKEN = 'crc_session_token';
const SESSION_ID = 'crc_session_id';

export function setFlowOverride(flow) {
  try {
    if (flow === 'direct' || flow === 'school') sessionStorage.setItem(FLOW, flow);
    else sessionStorage.removeItem(FLOW);
  } catch {
    /* ignore */
  }
}

export function clearFlowStorage() {
  try {
    sessionStorage.removeItem(FLOW);
    sessionStorage.removeItem(TOKEN);
    sessionStorage.removeItem(SESSION_ID);
  } catch {
    /* ignore */
  }
}

export function getFlowOverride() {
  try {
    const s = sessionStorage.getItem(FLOW);
    if (s === 'direct' || s === 'school') return s;
  } catch {
    /* ignore */
  }
  return null;
}

export function setSessionToken(t) {
  try {
    if (t) sessionStorage.setItem(TOKEN, String(t));
    else sessionStorage.removeItem(TOKEN);
  } catch {
    /* ignore */
  }
}

export function getSessionToken() {
  try {
    return sessionStorage.getItem(TOKEN) || '';
  } catch {
    return '';
  }
}

export function setSessionId(id) {
  try {
    if (id) sessionStorage.setItem(SESSION_ID, String(id));
    else sessionStorage.removeItem(SESSION_ID);
  } catch {
    /* ignore */
  }
}

export function getSessionId() {
  try {
    return sessionStorage.getItem(SESSION_ID) || '';
  } catch {
    return '';
  }
}
